import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ size = 60, color = 'primary', text = 'Chargement...' }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 1));
        }, 50);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100vh"
        >
            <Box position="relative" display="inline-flex">
                <CircularProgress
                    variant="determinate"
                    value={progress}
                    size={size}
                    color={color}
                    thickness={4}
                />
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography variant="caption" component="div" color="white">
                        {`${Math.round(progress)}%`}
                    </Typography>
                </Box>
            </Box>
            {text && (
                <Typography
                    variant="body1"
                    color="white"
                    mt={2}
                >
                    {text}
                </Typography>
            )}
        </Box>
    );
};

export default LoadingSpinner;